import BaseModel from "@/core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class CollectionsModel extends BaseModel {
  customer = null;
  is_collected_by_third_party = false;
  collector = null;
  collector_note = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  attributeLabels = {
    is_collected_by_third_party: i18n.t('Collected by 3rd Party'),
    collector: i18n.t('Collector'),
    collector_note: i18n.t('Note'),
  };

  getRequestData() {
    return this.is_collected_by_third_party
      ? {
        is_collected_by_third_party: this.is_collected_by_third_party,
        collector: this.collector,
        collector_note: this.collector_note,
      }
      : {
        is_collected_by_third_party: this.is_collected_by_third_party,
        collector: null,
        collector_note: null,
      }
  }
}
